'use client';

import { useTranslations } from 'next-intl';
import CWButton from '@/context/global/components/g00/g00-d00-g006-cw-button';
import PlayWarning from '@/context/global/assets/PlayWarning';

export interface ErrorVideoPlayerProps {
  message?: string;
  onClickOk?: () => void;
}

const ErrorVideoPlayer = ({ message, onClickOk }: ErrorVideoPlayerProps) => {
  const t = useTranslations('KaraokeError');

  const displayMessage = message ?? t('videoCannotBePlayed');

  return (
    <div className="bg-background mt-10 flex min-h-screen w-full items-start justify-center px-4 md:mt-0 md:items-center">
      <div className="flex flex-col items-center gap-6">
        {/* Play Warning Icon */}
        <PlayWarning className="ml-4 h-auto w-[80px] sm:w-[100px] lg:w-[110px]" />

        {/* Text Content */}
        <div className="flex flex-col items-center gap-1 text-center text-white">
          <p className="text-lg font-bold sm:text-xl lg:text-2xl">{t('oops')}</p>
          <p className="text-sm font-normal text-white/80 sm:text-base lg:text-lg">
            {displayMessage}
          </p>
        </div>

        {/* OK Button */}
        <div className="w-full max-w-[180px] sm:max-w-[200px]">
          <CWButton
            title={t('ok')}
            variant="white"
            className="h-[48px] rounded-lg text-base font-bold sm:h-[52px] sm:text-lg"
            onClick={onClickOk}
          />
        </div>
      </div>
    </div>
  );
};

export default ErrorVideoPlayer;
